import { SimpleSelect } from '@retailer-platform/shared-components'
import React, { type FunctionComponent, useMemo } from 'react'
import { type Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { useDomainMessages } from 'domains/collections/utils/domain/intl'
import { type CollectionsFormData } from 'domains/collections/components/collections-form/utils/collectionsForm.types'
import { useSearchParentCollectionCandidates } from 'domains/collections/api/searchParentCollectionCandidates.hooks'
import { type CollectionTypeEnum } from 'domains/collections/api'
import { CollectionsFormInputWrapper } from 'domains/collections/components/collections-form/components/form-input/CollectionsFormInputWrapper'
import { mapCollectionsToOptions } from './utils/CollectionsDetails.utils'

interface CollectionsDetailsParentProps {
  control: Control<CollectionsFormData>
  collectionId: string
  retailerId?: string
  collectionType: CollectionTypeEnum
}

export const CollectionsDetailsParent: FunctionComponent<CollectionsDetailsParentProps> = ({
  control,
  retailerId = '',
  collectionId,
  collectionType,
}) => {
  const messages = useDomainMessages({
    label: 'collectionsDomain.collectionsForm.section.details.parent.label',
    placeholder: 'collectionsDomain.collectionsForm.section.details.parent.placeholder',
  })

  const { collections, apiLoading, apiError } = useSearchParentCollectionCandidates({
    retailerId,
    collectionId,
    collectionTypes: [collectionType],
  })

  const collectionOptions = useMemo(
    () =>
      mapCollectionsToOptions({
        defaultLabel: messages.placeholder,
        collections: collections ?? [],
        editMode: Boolean(collectionId),
      }),
    [collections, messages.placeholder, collectionId]
  )

  return (
    <CollectionsFormInputWrapper label={messages.label}>
      <Controller
        as={SimpleSelect}
        name="details.parentId"
        options={collectionOptions}
        loading={apiLoading}
        error={apiError}
        defaultValue=""
        control={control}
      />
    </CollectionsFormInputWrapper>
  )
}
